module.exports = __webpack_public_path__ + "static/img/home_banner3@2x.7f39ef74.png";